<div class="card">
  <app-header
    titulo="Contratos Integrados"
    descricao="Visualização dos contratos integrados no ERP"
  ></app-header>


  <app-contratos></app-contratos>

</div>
